import React, { useState } from 'react';
import './Contact.css';
import { API_BASE_URL } from '../config/api';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    // Convert FormData to JSON object
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      subject: formData.get('subject'),
      message: formData.get('message')
    };

    setIsSubmitting(true);

    try {
      console.log('=== CONTACT FORM SUBMISSION ===');
      console.log('Submitting to:', `${API_BASE_URL}/api/contact`);
      console.log('Data:', data);

      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();
      
      console.log('=== BACKEND RESPONSE ===');
      console.log('Success:', result.success);
      console.log('Message:', result.message);
      console.log('========================');

      if (result.success) {
        setSubmitted(true);
        form.reset();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        alert(result.message || 'There was an error sending your message. Please try again.');
      }
    } catch (error) {
      console.error('Network error:', error);
      alert('Network error. Please make sure you are connected to the internet and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">

      {/* Page Banner */}
      <div className="contact-banner">
        <div className="contact-banner-content">
          <p className="contact-banner-eyebrow">We're here to help</p>
          <h1>Contact Us</h1>
          <p className="contact-banner-sub">Have a question or want to work together? Drop us a line.</p>
        </div>
      </div>

      {/* Floating background objects – left side */}
      <div className="contact-floats" aria-hidden="true">
        {/* Left column */}
        <div className="cf-left-1"></div>
        <div className="cf-left-2"></div>
        <div className="cf-left-3"></div>
        <div className="cf-left-4"></div>
        <div className="cf-left-5"></div>
        <div className="cf-left-6"></div>

        {/* Right column */}
        <div className="cf-right-1"></div>
        <div className="cf-right-2"></div>
        <div className="cf-right-3"></div>
        <div className="cf-right-4"></div>
        <div className="cf-right-5"></div>
        <div className="cf-right-6"></div>
      </div>

      <div className="contact-wrapper">

        {/* Left Panel */}
        <div className="contact-panel-left">
          <p className="contact-eyebrow">Get in Touch</p>
          <h1 className="contact-title">We'd love to<br />hear from you</h1>
          <p className="contact-desc">
            Have a question, partnership idea, or just want to say hello?
            Reach out and we'll get back to you shortly.
          </p>

          <div className="contact-info-list">
            <div className="contact-info-row">
              <div className="cinfo-icon">
                <svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              </div>
              <div>
                <span className="cinfo-label">Email</span>
                <span className="cinfo-value">info@ak-tech.in</span>
              </div>
            </div>

            <div className="contact-info-row">
              <div className="cinfo-icon">
                <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.12.35.03.74-.24 1.02l-2.2 2.2z"/></svg>
              </div>
              <div>
                <span className="cinfo-label">Phone</span>
                <span className="cinfo-value">+91 8925531013</span>
                <span className="cinfo-value secondary">+0422 2992101</span>
              </div>
            </div>

            <div className="contact-info-row">
              <div className="cinfo-icon">
                <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z"/></svg>
              </div>
              <div>
                <span className="cinfo-label">Office</span>
                <span className="cinfo-value">PSG-STEP, E8 Block, PSG iTECH Campus,<br />Neelambur, Coimbatore – 641 062</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel – Form */}
        <div className="contact-panel-right">
          {submitted ? (
            <div className="contact-success">
              <div className="success-check">
                <svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              </div>
              <h3>Message Sent!</h3>
              <p>Thanks for reaching out. We'll get back to you within 24 hours.</p>
              <button className="contact-back-btn" onClick={() => setSubmitted(false)}>Send Another</button>
            </div>
          ) : (
            <>
              <h2 className="form-heading">Send a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-field">
                    <label htmlFor="cf-name">Full Name</label>
                    <input id="cf-name" type="text" name="name" placeholder="Your name" required />
                  </div>
                  <div className="form-field">
                    <label htmlFor="cf-email">Email Address</label>
                    <input id="cf-email" type="email" name="email" placeholder="you@example.com" required />
                  </div>
                </div>

                <div className="form-field">
                  <label htmlFor="cf-subject">Subject</label>
                  <input id="cf-subject" type="text" name="subject" placeholder="What's this about?" required />
                </div>

                <div className="form-field">
                  <label htmlFor="cf-message">Message</label>
                  <textarea id="cf-message" name="message" rows="5" placeholder="Tell us how we can help..." required></textarea>
                </div>

                <button type="submit" className="contact-submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                  <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
                </button>
              </form>
            </>
          )}
        </div>

      </div>
      
      {/* Full Page Loader */}
      {isSubmitting && (
        <div className="contact-loader">
          <div className="loader-content">
            <div className="spinner"></div>
            <p>Sending your message...</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Contact;
